export default "__VITE_ASSET__BXGUUH36__"